
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystacabbooking() {



    const cardData =
    {
        keyword: 'Innova Crysta Cab Booking',
        heading: 'Meghana Cab : Innova Crysta Cab Booking',
        headingDescription: 'Meghana Cab offers premium Innova Crysta Cab Booking services, perfect for long-distance travel, family trips, group outings, and corporate travel. The spacious and luxurious Toyota Innova Crysta comes with plush seating, ample luggage space, and top-notch comfort, making it the ideal choice for both city and outstation rides. Our professional drivers ensure a smooth, safe, and timely journey. Choose Meghana Cab for transparent pricing, doorstep pickup, and 24/7 customer assistance. Book your Innova Crysta Cab today with Meghana Cab and enjoy a premium travel experience that combines comfort, convenience, and reliability.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
   {
    "title": "Osho Ashram (Meditation Resort)",
    "description": "Nestled in lush Koregaon Park, this global meditation centre promotes wellness through guided meditations, yoga, therapies, and silent retreats. Housed in serene halls with beautifully maintained gardens, it provides a space for introspection and rejuvenation." 
  },
    {
    "title": "Sinhagad Fort",
    "description": "Perched at 1,317 m on the Sahyadri range, this ancient hill fortress—famed for the 1670 Battle of Sinhagad—offers rugged treks, two main gateways (Pune & Kalyan Darwaza), Tanaji Malusare’s memorial, and sweeping vistas of the Deccan Plateau. It’s a beloved weekend trek with food stalls serving local fare." 
  },
    {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Maratha Peshwas, this iconic fortification features grand teak gateways, granite walls, ornate fountains, and remnants of its former glory. Despite a destructive fire in 1828, the five surviving gates—like the Delhi and Mastani Darwaza—and the palace ruins offer a journey into Maratha power and intrigue, often brought to life during the evening light-and-sound show." 
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 with Italian arches and set amidst sprawling lawns, this palatial structure served both famine relief and later the Indian freedom struggle—Mahatma Gandhi and his family were interned here. Now a museum, it preserves Gandhi’s personal items and the samadhis of Kasturba Gandhi and Mahadev Desai, echoing India’s fight for independence." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century monolithic rock‑cut Shiva temple carved from basalt, this subterranean sanctum includes a circular Nandi mandapa with intricately carved pillars and a unique ‘underworld’ symbolism, all nestled within a peaceful urban heritage setting." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most celebrated sacred sites, this temple houses a lavishly adorned gold Ganesh idol and draws devotees year‑round. During Ganesh Chaturthi, its vibrant rituals, processions, and communal spirit make it a cultural highlight." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second‑highest hill at ~2,100 ft, crowned by the historic Peshwa-era Parvati Temple. A 103-step climb rewards visitors with rooftop city views, a small museum, and serene gardens—popular at sunrise and for spiritual solace." 
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Housing 20,000+ artifacts—ranging from decorative arts to musical instruments—this museum offers a vivid window into daily life in historical India. It recently introduced geofenced multilingual audio guides across its eight galleries. " 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial dedicated to Maratha warrior Mahadji Shinde (d.1794), featuring Rajasthani-style carved pavilions, colored glass windows, and serene courtyards. It marks both his cremation spot and enduring legacy." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning 130 acres at Pune’s edge, this family-friendly park includes a zoo, snake park, aviary, and botanical sections. It combines wildlife conservation with educational exhibits and picnic spaces." 
  }
],

"services": [
  {
    "name": "Book Innova Crysta in Pune",
    "description": "Reserve a premium Innova Crysta cab in Pune for all your travel needs. Whether it’s city rides, outstation journeys, or special occasions, enjoy spacious seating, modern amenities, and professional drivers who prioritize your safety and comfort."
  },
  {
    "name": "Innova Crysta Cab for Outstation Pune",
    "description": "Plan your outstation trips from Pune with our reliable Innova Crysta cab service. Ideal for long-distance travel, family vacations, or group tours, our vehicles are well-maintained and equipped with air conditioning for a comfortable and stress-free ride."
  },
  {
    "name": "Airport Transfer Innova Crysta Pune",
    "description": "Experience timely and hassle-free airport transfers in Pune with our Innova Crysta cabs. Our professional drivers monitor your flight schedules to ensure prompt pickups and drop-offs, letting you relax before or after your journey."
  },
  {
    "name": "Luxury Innova Crysta Rental Pune",
    "description": "Travel in style and luxury with our premium Innova Crysta rental service in Pune. Perfect for weddings, corporate events, or personal use, enjoy spacious interiors, elegant design, and impeccable chauffeur services for an unforgettable travel experience."
  },
  {
    "name": "Pune to Mumbai Innova Crysta Cab",
    "description": "Commute comfortably between Pune and Mumbai with our dedicated Innova Crysta cab service. Whether for business or leisure, our cabs offer punctuality, safety, and ample space for luggage and passengers to ensure a smooth journey."
  },
  {
    "name": "Innova Crysta for Weddings Pune",
    "description": "Make your wedding day special with our Innova Crysta cab service in Pune. With elegant interiors and courteous chauffeurs, our vehicles are perfect for transporting the bride, groom, or guests in comfort and style."
  },
  {
    "name": "AC Innova Crysta Taxi Hire Pune",
    "description": "Stay cool and comfortable during your travels around Pune with our air-conditioned Innova Crysta taxis. Suitable for city tours, family trips, and outstation journeys, our vehicles come with experienced drivers dedicated to your convenience."
  },
  {
    "name": "Online Innova Crysta Booking Pune",
    "description": "Book your Innova Crysta cab online in Pune with ease using our secure and user-friendly platform. Select your travel dates, customize your itinerary, and receive instant confirmation, all from the comfort of your home or office."
  },
  {
    "name": "Family Trip Innova Crysta Cab Pune",
    "description": "Plan memorable family trips with our spacious Innova Crysta cabs in Pune. Enjoy ample legroom, luggage space, and safety features that make traveling with your loved ones comfortable and enjoyable."
  },
  {
    "name": "Innova Crysta for Corporate Travel Pune",
    "description": "Impress your clients and ensure smooth corporate travel with our Innova Crysta cab services in Pune. We provide timely pickups, professional chauffeurs, and a premium travel experience tailored to business needs."
  },
  {
    "name": "Pune to Goa Innova Crysta Cab",
    "description": "Embark on a scenic journey from Pune to Goa in the comfort of an Innova Crysta cab. Our long-distance travel service ensures you enjoy the ride with spacious seating, air conditioning, and reliable drivers for a memorable trip."
  },
  {
    "name": "Group Travel Innova Crysta Pune",
    "description": "Travel together comfortably with your group using our Innova Crysta cabs in Pune. Perfect for friends, family outings, or corporate team trips, our vehicles accommodate 6 passengers with enough luggage space and premium amenities."
  },
  {
    "name": "6-Seater Crysta Pune Cab",
    "description": "Our 6-seater Innova Crysta cabs in Pune provide ample space for passengers and luggage, making them ideal for small groups or family travels. Enjoy comfortable seating, air conditioning, and experienced drivers for a smooth ride."
  },
  {
    "name": "Premium Innova Crysta Cab with Driver Pune",
    "description": "Experience premium travel with our chauffeur-driven Innova Crysta cabs in Pune. Our professional drivers ensure safe, punctual, and courteous service, so you can relax and focus on your trip without any worries."
  },
  {
    "name": "Outstation Tour Cab Innova Crysta Pune",
    "description": "Explore nearby destinations with our outstation tour Innova Crysta cabs from Pune. Perfect for weekend getaways or extended tours, our cabs offer comfort, reliability, and a hassle-free travel experience with knowledgeable drivers."
  }
],
"tableData": [
  ["Book Innova Crysta in Pune", "Innova Crysta Cab for Outstation Pune"],
  ["Airport Transfer Innova Crysta Pune", "Luxury Innova Crysta Rental Pune"],
  ["Pune to Mumbai Innova Crysta Cab", "Innova Crysta for Weddings Pune"],
  ["AC Innova Crysta Taxi Hire Pune", "Online Innova Crysta Booking Pune"],
  ["Family Trip Innova Crysta Cab Pune", "Innova Crysta for Corporate Travel Pune"],
  ["Pune to Goa Innova Crysta Cab", "Group Travel Innova Crysta Pune"],
  ["6-Seater Crysta Pune Cab", "Premium Innova Crysta Cab with Driver Pune"],
  ["Outstation Tour Cab Innova Crysta Pune", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Cab Service",
        "WhyChoosedescription": "Meghana Cab offers exclusive Innova Crysta bookings, providing a luxurious and spacious ride perfect for family outings, corporate travel, and long-distance journeys. With comfortable seating for up to 7 passengers and ample luggage space, the Innova Crysta ensures a smooth and enjoyable travel experience."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Our Innova Crysta cabs are regularly serviced and thoroughly sanitized to maintain the highest standards of hygiene and safety. Equipped with air-conditioning, plush interiors, and advanced features, these vehicles deliver comfort and peace of mind on every trip."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly trained, courteous, and knowledgeable about local routes and traffic conditions. They prioritize your safety and convenience, ensuring timely pickups and smooth navigation throughout your journey."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "We provide clear and upfront pricing for Innova Crysta bookings, inclusive of fuel, tolls, driver allowance, and taxes. Our competitive rates guarantee excellent value for your money with no surprise charges at the end of your ride."
    },
    {
        "WhyChooseheading": "Flexible Booking and Travel Options",
        "WhyChoosedescription": "Whether you require a one-way trip, round-trip, or hourly rental, our Innova Crysta cab service adapts to your schedule. Customize your booking with specific pickup and drop locations, multiple stops, and tailored itineraries."
    },
    {
        "WhyChooseheading": "Ideal for Family Trips and Group Travel",
        "WhyChoosedescription": "The spacious interiors and comfortable seating make the Innova Crysta an ideal choice for families and groups traveling together. Enjoy a relaxed journey with ample legroom, climate control, and smooth ride quality for longer trips."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking Process",
        "WhyChoosedescription": "Book your Innova Crysta cab anytime with our 24/7 customer support. Our friendly team is ready to assist with reservations, changes, and any special requirements, ensuring a hassle-free and seamless booking experience."
    },
    {
        "WhyChooseheading": "Perfect for Business Travelers and Airport Transfers",
        "WhyChoosedescription": "Our Innova Crysta cabs provide a professional and comfortable environment, making them ideal for corporate clients and airport transfers. Arrive on time and travel with convenience and style wherever your business takes you."
    }
]



























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab with Meghana Cab?",
        answer: "You can book your Innova Crysta cab by calling Meghana Cab at +91 9075462128 or through our website for quick and hassle-free booking."
    },
    {
        question: "What are the key features of the Innova Crysta cab service?",
        answer: "Our Innova Crysta cabs offer spacious seating, comfortable interiors, and are perfect for family trips, airport transfers, and group travel."
    },
    {
        question: "Are Meghana Cab drivers experienced in driving Innova Crysta vehicles?",
        answer: "Yes, our drivers are skilled and experienced in handling Innova Crysta vehicles for a smooth and safe ride."
    },
    {
        question: "Is the Innova Crysta cab available for both local and outstation trips?",
        answer: "Yes, you can book Innova Crysta cabs for local travel within the city or for outstation journeys."
    },
    {
        question: "Does the fare include tolls, fuel, and driver charges?",
        answer: "Our fares cover fuel, tolls, and driver charges. Any extra waiting time or parking fees may incur additional charges."
    },
    {
        question: "Are the Innova Crysta vehicles sanitized before each trip?",
        answer: "Yes, all vehicles are thoroughly sanitized before every journey to ensure your safety and hygiene."
    },
    {
        question: "Is Innova Crysta cab service available 24/7?",
        answer: "Yes, we operate round-the-clock to cater to your travel requirements anytime."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, stops can be arranged upon request. Please inform us during booking."
    },
    {
        question: "What payment methods do you accept for Innova Crysta bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I contact Meghana Cab to book an Innova Crysta cab?",
        answer: "Call us at +91 9075462128 anytime to book your Innova Crysta cab or get travel assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Vijay Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta cab was very comfortable and spacious. Perfect for our family trip with Meghana Cab.”',
    },
    {
        name: 'Mrs. Pooja Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent Innova Crysta service by Meghana Cab. The driver was professional and the vehicle spotless.”',
    },
];












































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const innovaCrystaCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Crysta Cab Booking in Pune",
  "image": "https://www.meghanacabs.com/assets/images/innova-crysta-cab-pune.jpg",
  "description": "Book Innova Crysta cab in Pune for airport transfers, outstation trips, weddings, corporate travel, and group tours with Meghana Cabs. Luxury, comfort, and affordability guaranteed.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "Book Innova Crysta in Pune",
    "Innova Crysta Cab for Outstation Pune",
    "Airport Transfer Innova Crysta Pune",
    "Luxury Innova Crysta Rental Pune",
    "Pune to Mumbai Innova Crysta Cab",
    "Innova Crysta for Weddings Pune",
    "AC Innova Crysta Taxi Hire Pune",
    "Online Innova Crysta Booking Pune",
    "Family Trip Innova Crysta Cab Pune",
    "Innova Crysta for Corporate Travel Pune",
    "Pune to Goa Innova Crysta Cab",
    "Group Travel Innova Crysta Pune",
    "6-Seater Crysta Pune Cab",
    "Premium Innova Crysta Cab with Driver Pune",
    "Outstation Tour Cab Innova Crysta Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Innova Crysta Cab Booking in Pune | Luxury & Outstation Taxi | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Innova Crysta cab in Pune for airport transfers, outstation trips, weddings, corporate travel, and group tours with Meghana Cabs. Luxury, comfort, and affordability guaranteed."
  />
  <meta
    name="keywords"
    content="Book Innova Crysta in Pune, Innova Crysta Cab for Outstation Pune, Airport Transfer Innova Crysta Pune, Luxury Innova Crysta Rental Pune, Pune to Mumbai Innova Crysta Cab, Innova Crysta for Weddings Pune, AC Innova Crysta Taxi Hire Pune, Online Innova Crysta Booking Pune, Family Trip Innova Crysta Cab Pune, Innova Crysta for Corporate Travel Pune, Pune to Goa Innova Crysta Cab, Group Travel Innova Crysta Pune, 6-Seater Crysta Pune Cab, Premium Innova Crysta Cab with Driver Pune, Outstation Tour Cab Innova Crysta Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(innovaCrystaCabSchema)}
  </script>
</Helmet>





            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystacabbooking;